import styled from 'styled-components'

import CreateEditCampaignFormUnstyled from './unstyled'
import brandTheme from '../../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const CreateEditCampaignForm = styled(CreateEditCampaignFormUnstyled)`
  .value {
    float: right;
  }
  .label {
    display: block;
    padding: 0;
    text-align: left;
    color: #546b81;
    font-family: 'Roboto Regular', Helvetica, Arial, sans-serif;
    line-height: 24px;
    margin: 0 0 10px 0;
    font-size: 16px;
    position: relative;
  }
  .inputHeader {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .errorLabel {
    font-size: 12px;
    color: red;
    font-family: 'Roboto Regular', Helvetica, Arial, sans-serif;
    margin-top: 6px;
  }
  .checkBoxTitle {
    font-family: 'Roboto Regular', Helvetica, Arial, sans-serif;
    color: #546b81;
    font-size: 12px;
    margin-left: 10px;
    cursor: pointer;
  }
  .checkBoxContainer {
    margin-top: 34px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .range-values {
    display: flex;
    justify-content: space-between;
  }
  input[disabled] {
    background-color: gainsboro;
  }
  .bonus-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h2 {
      display: inline-block;
    }
    margin-bottom: 40px;
  }
  .section-wrapper {
    padding: 40px;
    margin: 0 0 30px 0;
    width: 100%;
  }

  .bonus-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .calculated-text {
      height: 86px;
      margin-bottom: 24px;
      label {
        display: block;
        padding: 0;
        text-align: left;
        font-size: 16px;
        color: ${colors.secondary};
        font-family: 'Roboto Regular', Helvetica, Arial, sans-serif;
        line-height: 24px;
        margin: 0 0 10px 0;
        white-space: normal;
      }
      span {
        font-size: 24px;
      }
    }

    .field {
      margin-bottom: 24px;
    }
    .left-box,
    .right-box {
      margin-right: 48px;
      flex: 1;
    }
    .right-box {
      align-self: flex-start;
    }
  }
  .section-wrapper:nth-child(1) {
    .section-column:nth-child(2) {
      float: left;
      width: 360px;
      padding: 0 25px 0 0;

      .field:nth-child(2) {
        margin: 30px 0 0 0;
      }

      .field:nth-child(3) {
        margin: 30px 0 0 0;
      }
    }

    .section-column:nth-child(3) {
      padding: 0 0 0 25px;
      overflow: hidden;

      textarea {
        height: 164px;
      }
    }

    .field-array {
      margin: 40px 0 0 0;
    }
  }

  .section-wrapper.metrics {
    .metrics-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin: 0 0 30px 0;

      .section-column {
        width: 100%;
        position: relative;
        align-items: left;
        & + .section-column {
          margin-left: 24px;
        }
      }
      .section-button-column {
        width: 20%;
        padding: 30px 20px 0 20px;
      }
      .section-checkbox-column {
        width: 100%;
        padding: 30px 20px 0 20px;
      }
    }
  }

  .submit-button-wrapper {
    height: 48px;
    width: 182px;
    float: right;
    margin: 0 0 30px 0;
  }

  .input-with-icon {
    input {
      padding: 0 20px 0 40px;
    }

    &:after {
      display: block;
      position: absolute;
      color: ${props => props.theme.colors.primary};
      bottom: 16px;
      left: 20px;
    }

    &_percent {
      &:after {
        content: '%';
      }
    }
    &_currency {
      &:after {
        content: '$';
      }
    }
    &_currency_dollar {
      &:after {
        content: '$';
      }
    }
    &_currency_euro {
      &:after {
        content: '€';
      }
    }
    &_currency_pound {
      &:after {
        content: '£';
      }
    }
    &_currency_chf {
      &:after {
        content: 'CHF';
        left: 8px;
      }
    }
  }

  .section-title {
    margin-bottom: 16px;
    &-inline {
      display: inline;
    }
  }
  .type-buttons {
    display: flex;
    .submit-button-wrapper {
      margin-right: 8px;
    }
    .transparent input {
      background-color: #fff;
      color: ${props => props.theme.colors.primary};
      border: 0;
    }
    .transparent input[disabled] {
      color: #dcdcdc;
    }
  }
  .disabled-field {
    height: 86px;
    margin-bottom: 24px;
    label {
      display: block;
      padding: 0;
      text-align: left;
      font-size: 16px;
      color: ${colors.secondary};
      font-family: 'Roboto Regular', Helvetica, Arial, sans-serif;
      line-height: 24px;
      margin: 0 0 10px 0;
    }
    span {
      font-size: 24px;
    }
  }
  .printing-plan-btns {
    display: flex;
    justify-content: flex-end;
    margin: -40px 0px 40px 20px;
    button + button {
      margin-left: 16px;
    }
  }

  .asset-generation-warning {
    margin-top: 8px;
    font-size: 10px;
    color: #505050;
    font-family: 'Roboto Regular', Helvetica, Arial, sans-serif;
  }
`
